import ArticlePage from "@/pages/article/ArticlePage";

export default function VsDirectShopping() {
  return <ArticlePage slug="vigorbuy-spreadsheet-vs-direct-shopping" />;
}